<template>
  <div id="courseList">
    <div class="product-wrapper">
      <h3 class="title">{{product.courseName}}</h3>
      <div class="product-coontent">
        <img :src="product.courseImage ? product.courseImage : defaultCover" :onerror="errorCover">
        <div class="content-text">
          <h3>主讲教师：{{product.teacherName}}</h3>
          <p>{{product.courseDesc}}</p>
        </div>
      </div>
    </div>
    <div class="product-list">
      <h2>课程目录</h2>
      <ul class="list-wrapper">
        <li v-for="(item,index) in list" :key="index" @click="goCourse(item)">{{item.chapterName}}</li>
      </ul>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <el-pagination :current-page="curIndex" layout="prev, pager, next" :total="pageTotal" background :page-size="pageSize" prev-text="上一页" next-text="下一页" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    </div>
  </div>
</template>
<script>
import { isLoginApi } from '@/api/auth';
import { getCourseDetailApi, getCourseCatalogApi } from '@/api/courseDetail';
export default {
  name: 'CourseList',
  components: {},
  props: {},
  data () {
    return {
      isLogged: false, //是否登录
      defaultCover: require('@/assets/images/common/tu.png'),
      curIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      product: {},
      schoolID: null,
      list: [],
      errorCover: 'this.src="' + require('@/assets/images/common/tu.png') + '"',
    }
  },
  watch: {
    schoolID: function () {
      this.$store.dispatch('schoolInfo/getSchoolInfo', this.schoolID);
    }
  },
  created () {
    this.getCourseDetail();
    this.getCourseCatalog()
    //判断是否登录
    isLoginApi().then(data => {
      if (data.result.isLogin) {
        this.isLogged = true;
      } else {
        this.isLogged = false;
      }
    })
  },
  methods: {
    getCourseDetail () {
      const params = {
        courseId: Number(this.$route.params.id)
      }
      getCourseDetailApi(params).then(data => {
        if (data.success && data.result) {
          this.product = data.result;
          this.schoolID = this.product.schoolId;
        }
      })
    },
    getCourseCatalog () {
      const params = {
        courseId: Number(this.$route.params.id),
        pageNum: this.curIndex,
        pageSize: this.pageSize
      }
      getCourseCatalogApi(params).then(data => {
        if (data.success && data.result) {
          const { pageSize, total, pageNum, list } = data.result;
          this.pageTotal = total;
          this.pageSize = pageSize,
            this.pageNum = pageNum,
            this.list = list;
        }
      })
    },
    //跳转课程详情
    goCourse (val) {
      if (this.isLogged) {
        let { href } = this.$router.resolve({
          path: `/detail`,
          query: {
            courseId: val.courseId,
            chapterId: val.chapterId
          }
        });
        window.open(href, '_blank');
      } else {
        this.$SignIn();
      }
    },
    handleCurrentChange (size) {
      this.curIndex = size;
      this.getCourseCatalog();
    },
    handleSizeChange (size) {
      this.curIndex = 1;
      this.pageSize = size;
    },
  }
};
</script>
